const generateCognitoPassword = (length = 12) => {
  const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const lowercase = 'abcdefghijklmnopqrstuvwxyz';
  const numbers = '0123456789';
  const specials = "!@#$%^&*()_+-=[]{}|'";

  // Ensure at least one character from each character set
  const randomChar = (chars) => chars[Math.floor(Math.random() * chars.length)];
  let password = [
    randomChar(uppercase),
    randomChar(lowercase),
    randomChar(numbers),
    randomChar(specials),
  ];

  // Fill remaining characters with random selection from all sets
  const allChars = uppercase + lowercase + numbers + specials;
  for (let i = password.length; i < length; i++) {
    password.push(randomChar(allChars));
  }

  // Shuffle the array to avoid predictable patterns
  password = password.sort(() => Math.random() - 0.5).join('');

  return password;
};

export { generateCognitoPassword };
